import { render, staticRenderFns } from "./JwzhBlock.vue?vue&type=template&id=468eec6b&scoped=true"
import script from "./JwzhBlock.vue?vue&type=script&lang=js"
export * from "./JwzhBlock.vue?vue&type=script&lang=js"
import style0 from "./JwzhBlock.vue?vue&type=style&index=0&id=468eec6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468eec6b",
  null
  
)

export default component.exports